import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const HistoryPagination = ({
  totalCount,
  totalPages,
  perPage,
  setPerPage,
  currentPage,
  setCurrentPage,
}) => {
  // Adjust the current page if it exceeds the new totalPages after perPage change
  const handlePerPageChange = (e) => {
    const newPerPage = Number(e.target.value);
    setPerPage(newPerPage);

    const newTotalPages = Math.ceil(totalCount / newPerPage);

    // Ensure the currentPage is not out of bounds
    if (currentPage > newTotalPages) {
      setCurrentPage(newTotalPages);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  return (
    <div className="flex justify-between w-full items-center h-[36px] text-sm font-semibold">
      {/* Left div */}
      <div className="flex items-center gap-2 h-full">
        {/* Per Page Selector */}
        <div className="select relative">
          <select
            className="appearance-none h-[36px] rounded border border-core-black-contrast-2 bg-core-black-contrast py-[7px] pl-3 pr-10 outline-none"
            value={perPage}
            onChange={handlePerPageChange}
          >
            {[8, 12, 16, 20].map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <p>Per page</p>
        <p className="ml-6">{totalCount} results</p>
      </div>

      {/* Right div */}
      <div className="flex items-center gap-3.5 text-core-grey-20">
        <button
          onClick={handleFirstPage}
          disabled={currentPage === 1}
          className={`w-5 h-5 flex items-center justify-center
            ${currentPage === 1 && 'text-core-grey-80 cursor-not-allowed'}`}
        >
          <KeyboardDoubleArrowLeftIcon />
        </button>
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className={`w-5 h-5 flex items-center justify-center 
            ${currentPage === 1 && 'text-core-grey-80 cursor-not-allowed'}`}
        >
          <KeyboardArrowLeftIcon />
        </button>
        <div className="flex items-center gap-2">
          <p className="w-10 h-9 px-3 py-2 rounded border border-core-black-contrast-2 bg-core-black-contrast text-center">
            {currentPage}
          </p>
          <p>{`${currentPage} - ${totalPages}`}</p>
        </div>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`w-5 h-5 flex items-center justify-center
            ${currentPage === totalPages && 'text-core-grey-80 cursor-not-allowed'}`}
        >
          <KeyboardArrowRightIcon />
        </button>
      </div>
    </div>
  );
};
export default HistoryPagination;
